import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search-text-input',
  template: `
    <div class="has-feedback {{ width }}">
      <input
        type="text"
        class="form-control"
        value="{{ value }}"
        placeholder="{{ placeHolder | translate }}"
        [required]="isRequired"
        [appAllowPattern]="pattern"
        (change)="search($event)"
        *ngIf="!eventType"
      />

      <input
        type="text"
        class="form-control"
        value="{{ value }}"
        placeholder="{{ placeHolder | translate }}"
        [required]="isRequired"
        [appAllowPattern]="pattern"
        (keyup)="search($event)"
        *ngIf="eventType === 'keyup'"
      />

      <span *ngIf="value" class="form-control-feedback feedback-close" (click)="clearSearch()">
        <i class="fa fa-times"></i>
      </span>
    </div>
  `,
})
export class SearchTextInputComponent {
  @Input() field: any;
  @Input() value: any = '';
  @Input() pattern: string;
  @Input() placeHolder: string;
  @Input() width: string;
  @Input() isRequired: boolean = false;
  @Input() eventType: string = '';

  @Output() private searched = new EventEmitter<{ field: any; value: any }>();

  private previousValue = '';

  search(event) {
    // if (event.target.value === this.previousValue) return;

    this.value = event.target.value;
    this.previousValue = this.value;

    this.searched.emit({ field: this.field, value: this.value }); // this.value
  }

  clearSearch() {
    setTimeout(() => {
      this.value = '';

      this.searched.emit({ field: this.field, value: '' });
    }, 50);
  }
}

/*

// inputValue = '';
  // inputValue = this.value;

<!-- (keydown.enter)="search($event)" -->

<!-- #searchText -> search(searchText.value) -->
      <!-- [appOnBlurChange]="searched()" -->

*/

// implements OnChanges, OnInit
// ngOnInit(): void {
// console.log('ngOnInit');
// console.log(this.value);
// }

// ngOnChanges(): void {
// console.log('ngOnChanges');
// console.log(this.value);
// this.inputValue = this.value;
// }

// @Input() value: any;
// @Output() private searched = new EventEmitter<any>();
// delete this.value;
// if (!value) return;
/* searchEnter(value) {
  if (value === this.previousValue) return;

  this.search(value);
} */

// @Input() isKeyUp: boolean = false; // every key type
